export const defaultColors = [
  // Alternative 5-Option
  "#cfe0c3",
  "#1f363d",
  "#40798c",
  "#70a9a1",
  "#9ec1a3",
];

export const iconColors = [
  "#264653",
  "#2A9D8F",
  "#E9C46A",
  "#F4A261",
  "#E76F51",
];

export const getManufacturingEventTypeColor = (eventType) => {
  const tempIndex = IncidentTypesManufacturing.apiCallAllEvents.indexOf(eventType);
  return defaultColors[tempIndex % defaultColors.length];
}

export const IncidentTypesManufacturing = {
  statCardsCountEvents: [
    "Restricted Zone Entry Started",
    "Machine Up",
    "Machine Down"
  ],
  statCardsDurationEvents: [],
  barChartEvents: [
    "Restricted Zone Entry Started",
    "Machine Up",
    "Machine Down",
    "Person Entered",
    "Person Exited",
    "Helmet Violation",
    "Glove Violation",
    "Safety Vest Violation",
    "Collision Risk Detected",
    "Employee Idle",
    "Employee Not Present",
    "Employee Present",
    "Min Occupancy Violation",
    "Max Occupancy Violation",
    //"Loitering Detected",
    "Loitering Started",
    "Loitering Ended",
    "Hairnet Violation",
    "Face Mask Violation",
    //"Perimeter Breach Detected",
    "Perimeter Breach Started",
    "Perimeter Breach Ended",
    //"Restricted Zone Entry",
    //"Trespass Detected",
    "Trespass Started",
    "Trespass Ended",
  ],
  pieChartEvents: [
    "Restricted Zone Entry Started",
    "Machine Up",
    "Machine Down",
    "Person Entered",
    "Person Exited",
    "Helmet Violation",
    "Glove Violation",
    "Safety Vest Violation",
    "Collision Risk Detected",
    "Employee Idle",
    "Employee Not Present",
    "Employee Present",
    "Min Occupancy Violation",
    "Max Occupancy Violation",
    //"Loitering Detected",
    "Loitering Started",
    "Loitering Ended",
    "Hairnet Violation",
    "Face Mask Violation",
    //"Perimeter Breach Detected",
    "Perimeter Breach Started",
    "Perimeter Breach Ended",
    //"Restricted Zone Entry",
    //"Trespass Detected",
    "Trespass Started",
    "Trespass Ended",
  ],
  timeLineEvents: [
    "Restricted Zone Entry Started",
    "Machine Up",
    "Machine Down",
    //"Person Entered",
    //"Person Exited",
    "Helmet Violation",
    "Glove Violation",
    "Safety Vest Violation",
    "Collision Risk Detected",
    "Employee Idle",
    "Employee Not Present",
    "Employee Present",
    "Min Occupancy Violation",
    "Max Occupancy Violation",
    //"Loitering Detected",
    //"Loitering Started",
    "Loitering Ended",
    "Hairnet Violation",
    "Face Mask Violation",
    //"Perimeter Breach Detected",
    //"Perimeter Breach Started",
    "Perimeter Breach Ended",
    //"Restricted Zone Entry",
    //"Trespass Detected",
    //"Trespass Started",
    "Trespass Ended",
  ],
  topBarDropdownEvents: [
    "Restricted Zone Entry Started",
    "Machine Up",
    "Machine Down",
    "Person Entered",
    "Person Exited",
    "Helmet Violation",
    "Glove Violation",
    "Safety Vest Violation",
    "Collision Risk Detected",
    "Employee Idle",
    "Employee Not Present",
    "Employee Present",
    "Min Occupancy Violation",
    "Max Occupancy Violation",
    //"Loitering Detected",
    "Loitering Started",
    "Loitering Ended",
    "Hairnet Violation",
    "Face Mask Violation",
    //"Perimeter Breach Detected",
    "Perimeter Breach Started",
    "Perimeter Breach Ended",
    //"Restricted Zone Entry",
    //"Trespass Detected",
    "Trespass Started",
    "Trespass Ended",
  ],
  apiCallAllEvents: [
    "Restricted Zone Entry Started",
    "Machine Up",
    "Machine Down",
    "Person Entered",
    "Person Exited",
    "Helmet Violation",
    "Glove Violation",
    "Safety Vest Violation",
    "Collision Risk Detected",
    "Employee Idle",
    "Employee Not Present",
    "Employee Present",
    "Min Occupancy Violation",
    "Max Occupancy Violation",
    //"Loitering Detected",
    "Loitering Started",
    "Loitering Ended",
    "Hairnet Violation",
    "Face Mask Violation",
    //"Perimeter Breach Detected",
    "Perimeter Breach Started",
    "Perimeter Breach Ended",
    //"Restricted Zone Entry",
    //"Trespass Detected",
    "Trespass Started",
    "Trespass Ended",
  ],
  eventReplayPageEvents: [
    "Restricted Zone Entry Started",
    "Machine Up",
    "Machine Down",
    "Person Entered",
    "Person Exited",
    "Helmet Violation",
    "Glove Violation",
    "Safety Vest Violation",
    "Collision Risk Detected",
    "Employee Idle",
    "Employee Not Present",
    "Employee Present",
    "Min Occupancy Violation",
    "Max Occupancy Violation",
    //"Loitering Detected",
    "Loitering Started",
    //"Loitering Ended",
    "Hairnet Violation",
    "Face Mask Violation",
    //"Perimeter Breach Detected",
    "Perimeter Breach Started",
    //"Perimeter Breach Ended",
    //"Trespass Detected",
    "Trespass Started",
    //"Trespass Ended",
  ]
}

export const getGEEventTypeColor = (eventType) => {
  if (eventType === 'Machine Up Started' ||
    eventType === 'Machine Up Ended'
  ) { return '#00695C' } // Dark Green
  else if (eventType === 'Machine Down Started' ||
    eventType === 'Machine Down Ended'
  ) { return '#b71c1c' } // red

  else if (eventType === 'Number Plate Detected') { return "#cfe0c3" }
  else if (eventType === 'C Hook With Rack Detected' ||
    eventType === 'C Hook With Rack Started' ||
    eventType === 'C Hook With Rack Ended' ||
    eventType === 'Rack With Parts Started' ||
    eventType === 'Rack With Parts Ended' ||
    eventType === 'Unfinished Part Detected' ||
    eventType === 'Rack With Parts Detected'
  ) { return "#1f363d" } // Dark Blue
  else if (eventType === 'Empty Rack Started' ||
    eventType === 'Empty Rack Started' ||
    eventType === 'Empty Rack Ended' ||
    eventType === 'Empty Rack Detected' ||
    eventType === 'C Hook Without Rack Started' ||
    eventType === 'C Hook Without Rack Ended' ||
    eventType === 'C Hook Without Rack Detected' ||
    eventType === 'Rework Part Detected'

  ) { return "#FFAB40" } // Yellow
  else return "#9ec1a3";
}

export const durationStatcardMapping = {
  "Machine Up Ended": "Machine Up",
  "Machine Down Ended": "Machine Down",
  "Empty Rack Ended": "Empty Rack",
  "Rack With Parts Ended": "Rack With Parts",
  "C Hook With Rack Ended": 'C Hook With Rack',
  "C Hook Without Rack Ended": "C Hook Without Rack"
}

export const IncidentTypesGE = {
  statCardsCountEvents: [
    "Machine Up Started",
    "Machine Down Started",
    "Number Plate Detected",
    "C Hook With Rack Detected",
    "C Hook Without Rack Detected",
    "Empty Rack Detected",
    "Rack With Parts Detected",
    "Unfinished Part Detected",
    "Rework Part Detected"
  ],
  statCardsDurationEvents: [
    "Machine Up Ended",
    "Machine Down Ended",
    "Empty Rack Ended",
    "Rack With Parts Ended",
    "C Hook With Rack Ended",
    "C Hook Without Rack Ended"
  ],
  barChartEvents: [
    "Number Plate Detected",
    "C Hook With Rack Detected",
    "C Hook Without Rack Detected",
    "Empty Rack Detected",
    "Rack With Parts Detected",
    "Unfinished Part Detected",
    "Machine Up Started",
    "Machine Down Started",
    "Empty Rack Started",
    "Rack With Parts Started",
    "C Hook With Rack Started",
    "C Hook Without Rack Started"
  ],
  pieChartEvents: [
    "Number Plate Detected",
    "C Hook With Rack Detected",
    "C Hook Without Rack Detected",
    "Empty Rack Detected",
    "Rack With Parts Detected",
    "Unfinished Part Detected",
    "Machine Up Started",
    "Machine Down Started",
    "Empty Rack Started",
    "Rack With Parts Started",
  ],
  timeLineEvents: [
    "C Hook Without Rack Detected",
    "Empty Rack Detected",
    "Machine Up Started",
    "Machine Up Ended",
    "Machine Down Started",
    "Machine Down Ended",
    "Empty Rack Started",
    "Empty Rack Ended",
    "Rack With Parts Started",
    "Rack With Parts Ended",
    "C Hook With Rack Started",
    "C Hook With Rack EndedStarted",
    "C Hook Without Rack Started",
    "C Hook Without Rack Ended"
  ],
  topBarDropdownEvents: [
    "Machine Up Started",
    "Machine Up Ended",
    "Machine Down Started",
    "Machine Down Ended",
    "Number Plate Detected",
    "C Hook With Rack Detected",
    "C Hook Without Rack Detected",
    "Empty Rack Started",
    "Empty Rack Ended",
    "Empty Rack Detected",
    "Rack With Parts Started",
    "Rack With Parts Ended",
    "Rack With Parts Detected",
    "Unfinished Part Detected",
    "Rework Part Detected"
  ],
  apiCallAllEvents: [
    "Machine Up Started",
    "Machine Up Ended",
    "Machine Down Started",
    "Machine Down Ended",
    "Number Plate Detected",
    "C Hook With Rack Detected",
    "C Hook Without Rack Detected",
    "Empty Rack Started",
    "Empty Rack Ended",
    "Empty Rack Detected",
    "Rack With Parts Started",
    "Rack With Parts Ended",
    "Rack With Parts Detected",
    "Unfinished Part Detected",
    "Rework Part Detected",
    "C Hook With Rack Ended",
    "C Hook Without Rack Ended",
    "C Hook With Rack Started",
    "C Hook Without Rack Started"
  ],
  eventReplayPageEvents: [
    "Machine Up Started",
    "Machine Down Started",
    "Empty Rack Started",
    "Rack With Parts Started",
  ]
}

export const IncidentTypesEmpty = {
  statCardsCountEvents: [],
  statCardsDurationEvents: [],
  barChartEvents: [],
  pieChartEvents: [],
  timeLineEvents: [],
  topBarDropdownEvents: [],
  apiCallAllEvents: [],
  eventReplayPageEvents: []
}

export const getAHFEventTypeColor = (eventType) => {
  if (eventType === 'Underfill Detected' ||
    eventType === 'Overfill Detected') {
    return '#b71c1c';
  } else if (eventType === "Box Fill OK") { return '#17b696' }
  else if (eventType === 'Workbench Empty') { return defaultColors[0] }
  else if (eventType === 'Box Fill Started') { return defaultColors[1] }
  else if (eventType === 'Box Fill Ended') { return defaultColors[2] }
  else return "#9ec1a3";
}

export const IncidentTypesAHF = {
  statCardsCountEvents: [
    "Underfill Detected",
    "Box Fill OK",
    "Overfill Detected"
  ],
  statCardsDurationEvents: [],
  barChartEvents: [
    "Box Fill Started",
    "Underfill Detected",
    "Box Fill OK",
    "Overfill Detected"
  ],
  pieChartEvents: [
    "Box Fill Started",
    "Underfill Detected",
    "Box Fill OK",
    "Overfill Detected"
  ],
  timeLineEvents: [
    "Workbench Empty",
    "Box Fill Started",
    "Underfill Detected",
    "Box Fill OK",
    "Overfill Detected",
    "Box Fill Ended"
  ],
  topBarDropdownEvents: [
    "Workbench Empty",
    "Box Fill Started",
    "Underfill Detected",
    "Box Fill OK",
    "Overfill Detected",
    "Box Fill Ended"
  ],
  apiCallAllEvents: [
    "Workbench Empty",
    "Box Fill Started",
    "Underfill Detected",
    "Box Fill OK",
    "Overfill Detected",
    "Box Fill Ended"
  ],
  eventReplayPageEvents: [
    "Underfill Detected",
    "Box Fill OK",
    "Overfill Detected"
  ]
}

export const buttonSelectedStyle = {
  color: 'white',
  backgroundColor: '#17b696',
  boxShadow: 'none',
  textTransform: 'none',
  marginRight: '10px',
  fontFamily: 'Lato',
  padding: '5px 15px'
}

export const buttonUnselectedStyle = {
  color: 'white',
  backgroundColor: 'lightgray',
  boxShadow: 'none',
  textTransform: 'none',
  marginRight: '10px',
  fontFamily: 'Lato',
  padding: '5px 15px'
}

export const IncidentTypesDMS = {
  statCardsCountEvents: ["Lane Violation", "Collision Risk Detected"],
  statCardsDurationEvents: [],
  barChartEvents: ["Lane Violation", "Collision Risk Detected"],
  pieChartEvents: ["Lane Violation", "Collision Risk Detected"],
  timeLineEvents: ["Lane Violation", "Collision Risk Detected"],
  topBarDropdownEvents: ["Lane Violation", "Collision Risk Detected"],
  apiCallAllEvents: ["Lane Violation", "Collision Risk Detected"],
  eventReplayPageEvents: ["Lane Violation", "Collision Risk Detected"]
}

export const getDMSEventTypeColor = (eventType) => {
  if (eventType === 'Lane Violation') { return '#b71c1c'; }
  else if (eventType === "Collision Risk Detected") { return '#FFAB40' }
  else return "#9ec1a3";
}

export const IncidentTypesDomtar = {
  statCardsCountEvents: [
    "Gantry Exiting Safe Zone",
    "Wet-end Crane Violation Started",
    "Dry-end Crane Violation Started",
  ],
  statCardsDurationEvents: [],
  barChartEvents: [
    "Gantry Exiting Safe Zone",
    "Wet-end Crane Violation Started",
    "Dry-end Crane Violation Started",
  ],
  pieChartEvents: [
    "Gantry Exiting Safe Zone",
    "Wet-end Crane Violation Started",
    "Dry-end Crane Violation Started",
  ],
  timeLineEvents: [
    "Gantry Entering Safe Zone",
    "Gantry Exiting Safe Zone",
    "Wet-end Crane Violation Started",
    "Wet-end Crane Violation Ended",
    "Dry-end Crane Violation Started",
    "Dry-end Crane Violation Ended"
  ],
  topBarDropdownEvents: [
    "Gantry Entering Safe Zone",
    "Gantry Exiting Safe Zone",
    "Wet-end Crane Violation Started",
    "Wet-end Crane Violation Ended",
    "Dry-end Crane Violation Started",
    "Dry-end Crane Violation Ended",
  ],
  apiCallAllEvents: [
    "Gantry Entering Safe Zone",
    "Gantry Exiting Safe Zone",
    "Wet-end Crane Violation Started",
    "Wet-end Crane Violation Ended",
    "Dry-end Crane Violation Started",
    "Dry-end Crane Violation Ended",
  ],
  eventReplayPageEvents: [
    "Gantry Exiting Safe Zone",
    "Wet-end Crane Violation Started",
    "Dry-end Crane Violation Started",
  ]
}

export const getDomtarEventTypeColor = (eventType) => {
  if (eventType === 'Crane Violation Started') { return '#b71c1c'; }
  else if (eventType === 'Gantry Exiting Safe Zone') { return '#FFAB40' }
  else if (eventType === 'Gantry Entering Safe Zone') { return '#cfe0c3' }
  else if (eventType === 'Wet-end Crane Violation Started') { return '#92a685' }
  else if (eventType === 'Wet-end Crane Violation Ended') { return '#40798c' }
  else if (eventType === 'Dry-end Crane Violation Started') { return '#70a9a1' }
  else if (eventType === 'Dry-end Crane Violation Ended') { return '#9ec1a3' }
  else return "#9ec1a3";
}

